module.exports = __webpack_public_path__ + "assets/img/sh2.5c74b1a9.jpg";